// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartLineContainerStyles } from "@werner/App/Components/Cart/CartLineContainer";
import { LinesHeaderStyles } from "@werner/App/Components/Cart/LinesHeader";
import { SectionTitleStyles } from "@werner/App/Components/Common/SectionTitle";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

interface OrderDetailsSharedStyles {
    sectionTitle?: SectionTitleStyles;
    linesHeaderStyles?: LinesHeaderStyles;
    cartLineContainer?: CartLineContainerStyles;
}

const orderDetailsSharedStyles: OrderDetailsSharedStyles = {
    sectionTitle: {
        wrapper: {
            css: css`
                margin-bottom: 20px;
                padding-top: 24px;
                &.share-entity-section-title {
                    padding-top: 0 !important;
                    border: none !important;
                    &:before {
                        content: " ";
                        display: block;
                        width: 100%;
                        height: 1px;
                        margin-bottom: 24px;
                        background: ${color("common.border")};
                    }
                }
            `,
        },
        title: {
            size: 28,
            css: css`
                letter-spacing: 0;
                line-height: 32px;
            `,
        },
    },
    linesHeaderStyles: {
        wrapper: {
            css: css`
                border-top: 2px solid ${color("common.border")};
                padding-top: 16px;
            `,
        },
    },
    cartLineContainer: {
        rightSideActions: {
            css: css`
                margin-top: auto;
            `,
        },
    },
};

export default orderDetailsSharedStyles;
